import React from 'react';
import BulkDeleteButtonWithConfirmation from './BulkDeleteButtonWithConfirmation';

export const CustomBulkActions = (props) => {
    return <BulkDeleteButtonWithConfirmation {...props} />;
};